import { localStorage, sessionStorage } from 'dibs-browser-storage';
import serverVars from 'server-vars';
import { getCurrency } from 'dibs-intl/exports/units';
import { getForcedCurrency } from 'dibs-currency-helpers/exports/getForcedCurrency.ts';
import currencies, { type SupportedCurrencies } from 'dibs-currency-helpers/exports/currencies.ts';

const UC = 'userCurrency';
function getValidCurrency(currency?: SupportedCurrencies | null): SupportedCurrencies | undefined {
    currency = currency ? currency.toUpperCase() : undefined;
    return !!currency && currencies.includes(currency) ? currency : undefined;
}

function getCurrencyPreference({
    userCurrency = '',
    regionalCurrency = '',
}: {
    userCurrency?: SupportedCurrencies | null;
    regionalCurrency?: SupportedCurrencies | null;
} = {}): SupportedCurrencies {
    const forcedCurrency = getForcedCurrency() || serverVars.get('settings.forcedCurrency');
    const sessionCurrency = getValidCurrency(sessionStorage.getItem(UC));
    const localCurrency = getValidCurrency(localStorage.getItem(UC));
    const validatedUserCurrency = getValidCurrency(userCurrency);
    const validatedRegionalCurrency = getValidCurrency(regionalCurrency);
    if (forcedCurrency) {
        sessionStorage.setItem(UC, forcedCurrency);
        return forcedCurrency;
    } else if (validatedUserCurrency) {
        localStorage.setItem(UC, validatedUserCurrency);
        return validatedUserCurrency;
    } else if (localCurrency) {
        return localCurrency;
    } else if (sessionCurrency) {
        return sessionCurrency;
    } else if (validatedRegionalCurrency) {
        sessionStorage.setItem(UC, validatedRegionalCurrency);
        return validatedRegionalCurrency;
    }

    const locale = serverVars.get('locale');
    return getCurrency(locale) as SupportedCurrencies;
}

function getLocalCurrency(): SupportedCurrencies | undefined {
    return getValidCurrency(localStorage.getItem(UC));
}

function getSessionCurrency(): SupportedCurrencies | undefined {
    return getValidCurrency(sessionStorage.getItem(UC));
}

function setLocalCurrency(currency: SupportedCurrencies): void {
    const valid = getValidCurrency(currency);
    if (valid) {
        localStorage.setItem(UC, valid);
    } else {
        // eslint-disable-next-line no-console
        console.warn(`invalid local currency supplied ${currency}`);
    }
}

export { getCurrencyPreference, getSessionCurrency, getLocalCurrency, setLocalCurrency };
